export const validateFileSize = (file, maxSize = 10 * 1024 * 1024) => {
  if (!file) return true;
  
  if (file.size > maxSize) {
    throw new Error(`File size must be less than 10MB. Current size: ${(file.size / (1024 * 1024)).toFixed(2)}MB`);
  }
  return true;
};

export const validateImageFile = (file) => {
  if (!file) return true;
  
  const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
  if (!validTypes.includes(file.type)) {
    throw new Error('Only JPEG, PNG, and GIF files are allowed');
  }
  
  return validateFileSize(file);
};
